import { apiSlice } from "../store/api/adminApi";

export const eventApi = apiSlice.injectEndpoints({
    endpoints: (build)=>({
        fetchEvents: build.query<any, any>({
            query: (body: {
                type: string, 
                skip: number,
                take: number,
                eventId?: number,
                filter: string
            }) => ({
                url: `/admin/events/list/${body.type}?${body?.eventId ? `eventId=${body.eventId}&` : ''}skip=${body.skip || 0}&take=${body.take || 10}${body.filter || ""}`
            }),
        }),
        fetchEventsCount: build.query<any, any>({
            query: () => ({
                url: `/admin/events/count/`
            }),
        }),
        hideEvent: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/hide/${id}`,
                method: 'PUT',
            }),
        }),
        changeEventPriority: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/priority/${id}`,
                method: 'PUT',
            }),
        }),
        showEvent: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/show/${id}`,
                method: 'PUT',
            }),
        }),
        resetEvent: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/reset/${id}`,
                method: 'PUT',
            }),
        }),
        confirmEvent: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/confirm/${id}`,
                method: 'PUT',
            }),
        }),
        deleteEvent: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/events/${id}`,
                method: 'DELETE',
            }),
        }),
        uploadFile: build.mutation<{}, {id: number, data: FormData}>({
            query({id, data}) {
              return {
                url: `/admin/events/pay/${id}`,
                method: 'POST',
                body: data,
              };
            },
        }),
        downloadReport: build.query<{}, { startDate: Date, endDate: Date, ignoreYeshInvoice: boolean, ignoreZCredit: boolean, ignoreTransactions: boolean }>({
            query({ startDate, endDate, ignoreYeshInvoice, ignoreZCredit, ignoreTransactions }) {
              return {
                url: `/admin/events/report/all?startDate=${startDate}&endDate=${endDate}&ignoreYeshInvoice=${ignoreYeshInvoice}&ignoreZCredit=${ignoreZCredit}&ignoreTransactions=${ignoreTransactions}&language=en`,
                method: 'GET',
                responseHandler: (response: any) => response.blob()
              };
            },
        }),
        openAsAdmin: build.query<{}, {id: number}>({
            query: ({id}) => ({
                  url: `/admin/open/event/${id}`
            }),
        }),

        getEventTransactionList: build.query({
            query: ({ eventId, type, transactionId, skip, take }: { eventId: number; type: string; transactionId?: number; skip?: number; take?: number; }) => ({
                url: `/admin/events/${eventId}/transaction/list/${type}?skip=${skip || 0}&take=${take || 10}${transactionId ? `&transactionId=${transactionId}` : ''}`,
            }),
        }),

        getEventTransactionListByType: build.query({
            query: ({ type, transactionId, skip, take }: { type: string; transactionId?: number; skip?: number; take?: number; }) => ({
                url: `/admin/events/transaction/list/${type}?skip=${skip || 0}&take=${take || 10}${transactionId ? `&transactionId=${transactionId}` : ''}`,
            }),
        }),

        progressTransaction: build.mutation({
            query: ({ eventId, transactionId }) => ({
                url: `/admin/events/${eventId}/transaction/${transactionId}/progress`,
                method: 'PUT',
            }),
        }),

        approveTransaction: build.mutation({
            query: ({ eventId, transactionId, adminNote = null }) => ({
                url: `/admin/events/${eventId}/transaction/${transactionId}/confirm`,
                method: 'PUT',
                body: { adminNote },
            }),
        }),
        
        declineTransaction: build.mutation({
            query: ({ eventId, transactionId, adminNote = null }) => ({
                url: `/admin/events/${eventId}/transaction/${transactionId}/decline`,
                method: 'PUT',
                body: { adminNote },
            }),
        }),
        getTransactionReceipt: build.query({
            query: ({ eventId, transactionId }) => ({
                url: `/admin/events/${eventId}/transaction/${transactionId}/receipt`,
                method: 'GET',
                responseHandler: (response: any) => response.blob()
            }),
        }),
        getEventScannerCrossList: build.query({
            query: ({ eventId }) => ({
                url: `/admin/event/${eventId}/scanner/cross`,
                method: 'GET',
            }),
        }),
        updateEventScannerCrossList: build.mutation({
            query: ({ eventId, relatedEventLinks = [] }) => ({
                url: `/admin/event/${eventId}/scanner/cross`,
                method: 'POST',
                body: { relatedEventLinks }
            }),
        }),
        getEventTicketList: build.query({
            query: ({ eventId }) => ({
                url: `/admin/event/${eventId}/ticket/list`,
                method: 'GET',
            }),
        }),
        giftEventTickets: build.mutation({
            query: ({ eventId, users = '', smsText = '', ticketId = null, ticketName = null }) => ({
                url: `/admin/event/${eventId}/ticket/gift`,
                method: 'POST',
                body: {
                    users,
                    smsText,
                    ticketId,
                    ticketName,
                }
            }),
        }),
    })
})